module.exports = __webpack_public_path__ + "img/color_cafe.2db6d06a.svg";